import styled from 'styled-components';
import { darken } from 'polished';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

function backgroundColorCSS({ $color }) {
  return nuDSColor($color);
}

function hoverFocusBackgroundColorCSS({ $color, theme }) {
  const nudsColor = nuDSColor($color)();

  return darken(0.05, nudsColor({ theme }));
}

export const ChipBase = styled.span`
    width: auto;
    cursor: pointer;
    font-size: .875rem;
    padding: .5rem 1.125rem;
    border-radius: 1.5rem;
    background-color: ${backgroundColorCSS};

    &:focus, &:hover {
      background-color: ${hoverFocusBackgroundColorCSS};
    }
`;
